// extracted by mini-css-extract-plugin
module.exports = {"address-input":"EditAddressDesktopInput_address-input__bLTbl","dropdown-item":"EditAddressDesktopInput_dropdown-item__kWCYm"};